/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Pick_FileInputs */

const en_us2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose CSV file`)
};

const pt_br2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher arquivo CSV`)
};

const es_419_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir archivo CSV`)
};

const pt_pt2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher ficheiro CSV`)
};

const fr_fr2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un fichier CSV`)
};

const de_de2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-Datei wählen`)
};

const it_it2_history_transfer_pick_file = /** @type {(inputs: History_Transfer_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli file CSV`)
};

/**
* | output |
* | --- |
* | "Choose CSV file" |
*
* @param {History_Transfer_Pick_FileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_pick_file = /** @type {((inputs?: History_Transfer_Pick_FileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Pick_FileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_pick_file(inputs)
	if (locale === "es-419") return es_419_history_transfer_pick_file(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_pick_file(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_pick_file(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_pick_file(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_pick_file(inputs)
	return en_us2_history_transfer_pick_file(inputs)
});
export { history_transfer_pick_file as "history-transfer.pick_file" }